import {Box, styled, Tooltip} from "@mui/material";
import React, {useEffect, useState} from "react";
import {generateAIDiagramData} from "../../helpers/generateAIDiagramDate";
import {activeAIDiagram} from "./activeAIDiagram";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import CalculateIcon from "@mui/icons-material/Calculate";
import ChatIcon from "@mui/icons-material/Chat";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import SsidChartIcon from "@mui/icons-material/SsidChart";
import PublicIcon from "@mui/icons-material/Public";
import SavingsIcon from "@mui/icons-material/Savings";

const AIDiagramContainer = styled(Box)({
    position: "relative",
    overflow: "auto",
    height: "fit-content",
});

const AIDiagramElement = styled(Box)({
    height: "50vh",
    width: "100%",
    minHeight: "600px",
    "@media(max-width: 768px)":{
        minWidth: "1500px",
    }
});

const AIDiagramElementHandler = styled(Box)({
    position: "absolute",
    height: "100%",
    width: "100%",
    top: 0,
    left: 0,
    "@media(max-width: 768px)":{
        minWidth: "1500px",
    }
});

const IconsContainer = styled(Box)({
    position: "absolute",
    height: "calc(100% - 40px)",
    left: "20px",
    top: "6px",
    display: "grid",
    zIndex: 3,
    justifyItems: "center",
    border: "2px solid #6d7a83",
    padding: "10px 5px",
    boxSizing: "border-box",
    borderRadius: "16px",
    "& p":{
        color: "#fff",
        fontSize: "12px",
        margin: 0,
        maxWidth: "80px",
    },
    "@media(max-width: 768px)":{
        justifyItems: "start",
    }
});

const AIDiagram = ():JSX.Element => {
    
    const icons = [     {
        name: "Opinion",component:  <ChatIcon htmlColor={"#FFFFFF"}/>
    },
    {
        name: "Economic",component:  <SavingsIcon htmlColor={"#FFFFFF"}/>
    },
    {
        name: "Geopolitical",component:  <PublicIcon htmlColor={"#FFFFFF"}/>
    },
    {
        name: "Indirect",component:  <AccountTreeIcon htmlColor={"#FFFFFF"}/>
    },
    {
        name: "Mathematical",component:  <CalculateIcon htmlColor={"#FFFFFF"}/>
    },
    {
        name: "Financial Analysis",component:  <SsidChartIcon htmlColor={"#FFFFFF"}/>
    },
    {
        name: "Related Assets Analysis",component:  <QueryStatsIcon htmlColor={"#FFFFFF"}/>
    },
    ];
    
    const renderIcons = ():React.ReactNode => {
        return <IconsContainer>
            <p>Sources Types</p>
            {icons.map((opt, index) => window.innerWidth > 768 ? <Tooltip key={"icon-" + index} title={opt.name}>
                {opt.component}
            </Tooltip> : <p key={"icon-" + index}> - {opt.name}</p>)}
        </IconsContainer>;
    };
    
    
    const [data1, setData1] = useState< (number | string)[][]>([]);
    const [data2, setData2] = useState< (number | string)[][]>([]);
    
    const initData = ():void => {
        setData1(generateAIDiagramData(20, [0, 200]));
        setData2(generateAIDiagramData(80,  [0, 200]));
    };
    
    useEffect(() => {
        if(data1.length && data2.length){
            activeAIDiagram(data1, data2);
        }
    },[data1, data2]);
    
    useEffect(() => {
        initData();
    },[]);
    
    
    return <AIDiagramContainer>
        {renderIcons()}
        <AIDiagramElement id={"aiDiagramElement"}/>
        <AIDiagramElementHandler/>
    </AIDiagramContainer>;
};

export default AIDiagram;
